import Skeleton from 'react-loading-skeleton';
import styled, { css } from 'styled-components';
import { toRem } from 'design';

interface InputLoaderProps {
  width?: number;
}

export const InputLoader = styled(Skeleton)<InputLoaderProps>`
  display: flex;
  width: 100% !important;
  height: ${toRem(44)};
  border-radius: ${toRem(5.5)};

  ${({ width }) =>
    width &&
    css`
      width: ${toRem(width)}!important;
    `}
`;
